// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  box-sizing: border-box;
}

ion-header {
  display: none;
}
@media (min-width: 991px) {
  ion-header {
    display: block;
  }
}

@media (max-width: 992px) {
  ion-content {
    --background: url('background_home_mobile.png') left top 98%/103% no-repeat;
    position: relative;
    --padding-start: 30px;
    --padding-end: 30px;
  }
}
ion-content .logo {
  height: 37px;
  width: 150px;
  position: absolute;
  top: 20px;
  left: 20px;
}
@media (min-width: 991px) {
  ion-content .logo {
    display: none;
  }
}
ion-content .main-block {
  margin-top: 90px;
  position: absolute;
  left: 0;
  bottom: 0;
  right: 0;
  background: #ebdfda;
  padding: 25px 30px 20px;
  border-top-left-radius: 26px;
  border-top-right-radius: 26px;
  text-align: center;
  color: var(--color-black);
}
ion-content .main-block .title {
  font-size: 18px;
  line-height: 20px;
  letter-spacing: 0%;
  color: var(--color-black);
  text-transform: uppercase;
  margin-bottom: 18px;
  text-align: center;
}
ion-content .main-block .auth-info {
  color: var(--color-black);
}

.main-button {
  --background: var(--ion-color-secondary);
  --color: var(--color-black);
  font-size: 12px;
  min-height: 40px;
  width: 180px;
}

@media (min-width: 991px) {
  .mobile {
    display: none;
  }
}

.main-desktop {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 100%;
}
@media (max-width: 992px) {
  .main-desktop {
    display: none;
  }
}
.main-desktop .left-block,
.main-desktop .right-block {
  width: 50%;
}
.main-desktop .left-block {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.main-desktop .left-block .top {
  height: 55%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 50px;
}
.main-desktop .left-block .top .title {
  max-width: 490px;
  text-wrap: balance;
  font-family: AppFontBold;
  font-size: 35px;
  line-height: 38px;
  letter-spacing: 0em;
  text-align: center;
  text-transform: uppercase;
  margin-bottom: 4.5%;
}
.main-desktop .left-block .top .main-button {
  min-height: 50px;
  width: 46%;
  max-width: 310px;
  margin: 0 auto 17%;
  font-size: 20px;
  line-height: 23.2px;
  letter-spacing: 0.02em;
}
.main-desktop .left-block .top .auth-button {
  min-height: 54px;
  min-width: 218px;
  font-size: 20px;
  line-height: 23.2px;
  letter-spacing: 0.02em;
}
.main-desktop .left-block .full-height {
  height: 100%;
}
.main-desktop .left-block .bottom {
  height: 45%;
  width: 100%;
  overflow: auto;
  display: flex;
  flex-direction: column;
}
.main-desktop .left-block .bottom h4 {
  text-transform: uppercase;
  padding-left: 20px;
}
.main-desktop .left-block .bottom swiper-container {
  width: 100%;
  height: calc(100% - 24px);
  padding-block: 12px;
}
.main-desktop .right-block {
  height: 100%;
  background: url('background_home_desktop.png') no-repeat center/100% 100%;
}

.auth-info {
  font-family: AppFontMedium;
  font-size: 18px;
  line-height: 21.6px;
  letter-spacing: 0.08em;
  text-align: center;
  text-transform: uppercase;
  margin-bottom: 4.1%;
}
@media (max-width: 992px) {
  .auth-info {
    color: #fff;
  }
}
@media (min-width: 991px) {
  .auth-info {
    padding: 0 160px;
  }
}

@media (min-width: 991px) {
  ion-footer {
    display: none;
  }
}

.footer-wrapper {
  height: 72px;
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid #272727;
  background: #ebdfda;
}
.footer-wrapper .auth-info {
  font-family: AppFontMedium;
  font-size: 10px;
  line-height: 12px;
  letter-spacing: 8%;
}
.footer-wrapper ion-button {
  min-height: 40px;
  font-size: 12px;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/email-confirmation/email-confirmation.page.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AACA;EACC,sBAAA;AAAD;;AAGA;EACC,aAAA;AAAD;ACLE;EDIF;IAGE,cAAA;EAEA;AACF;;ACJE;EDKF;IAEE,2EAAA;IACA,kBAAA;IAEA,qBAAA;IACA,mBAAA;EACA;AACF;AAAC;EACC,YAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;AAEF;AC1BE;EDmBD;IAOE,aAAA;EAID;AACF;AADC;EACC,gBAAA;EACA,kBAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;EACA,mBAAA;EACA,uBAAA;EACA,4BAAA;EACA,6BAAA;EACA,kBAAA;EACA,yBAAA;AAGF;AADE;EACC,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;EAEA,yBAAA;EACA,mBAAA;EACA,kBAAA;AAEH;AAAE;EACC,yBAAA;AAEH;;AAGA;EACC,wCAAA;EACA,2BAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;AAAD;;AChEE;EDmEF;IAEE,aAAA;EAAA;AACF;;AAGA;EAKC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;AAJD;ACxEE;EDmEF;IAEE,aAAA;EAOA;AACF;AAAC;;EAEC,UAAA;AAEF;AACC;EACC,YAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AACF;AACE;EACC,WAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACG,mBAAA;EACH,aAAA;AACH;AAAG;EACC,gBAAA;EACA,kBAAA;EACA,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;AAEJ;AACG;EACC,gBAAA;EACA,UAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;EACA,sBAAA;AACJ;AAEG;EACC,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,sBAAA;AAAJ;AAIE;EACC,YAAA;AAFH;AAKE;EACC,WAAA;EACA,WAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;AAHH;AAIG;EACC,yBAAA;EACA,kBAAA;AAFJ;AAIG;EACC,WAAA;EACA,yBAAA;EACA,mBAAA;AAFJ;AAiBC;EACC,YAAA;EACA,yEAAA;AAfF;;AAmBA;EACC,0BAAA;EACA,eAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;AAhBD;AC5JE;EDqKF;IAUE,WAAA;EAfA;AACF;ACvKE;ED2KF;IAcE,gBAAA;EAdA;AACF;;AC5KE;ED8LF;IAEE,aAAA;EAfA;AACF;;AAkBA;EACC,YAAA;EACA,aAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EAEA,6BAAA;EACA,mBAAA;AAhBD;AAkBC;EACC,0BAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;AAhBF;AAmBC;EACC,gBAAA;EACA,eAAA;AAjBF","sourcesContent":["@import '../../../theme/mixins';\n* {\n\tbox-sizing: border-box;\n}\n\nion-header {\n\tdisplay: none;\n\t@include desktop {\n\t\tdisplay: block;\n\t}\n}\n\nion-content {\n\t@include mobile {\n\t\t--background: url('../../../assets/kaisin/background_home_mobile.png') left top 98%/103% no-repeat;\n\t\tposition: relative;\n\n\t\t--padding-start: 30px;\n\t\t--padding-end: 30px;\n\t}\n\t.logo {\n\t\theight: 37px;\n\t\twidth: 150px;\n\t\tposition: absolute;\n\t\ttop: 20px;\n\t\tleft: 20px;\n\t\t@include desktop {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n\n\t.main-block {\n\t\tmargin-top: 90px;\n\t\tposition: absolute;\n\t\tleft: 0;\n\t\tbottom: 0;\n\t\tright: 0;\n\t\tbackground: #ebdfda;\n\t\tpadding: 25px 30px 20px;\n\t\tborder-top-left-radius: 26px;\n\t\tborder-top-right-radius: 26px;\n\t\ttext-align: center;\n\t\tcolor: var(--color-black);\n\t\t\n\t\t.title {\n\t\t\tfont-size: 18px;\n\t\t\tline-height: 20px;\n\t\t\tletter-spacing: 0%;\n\t\t\tcolor: var(--color-black);\n\n\t\t\ttext-transform: uppercase;\n\t\t\tmargin-bottom: 18px;\n\t\t\ttext-align: center;\n\t\t}\n\t\t.auth-info {\n\t\t\tcolor: var(--color-black);\n\t\t}\n\t}\n}\n\n.main-button {\n\t--background: var(--ion-color-secondary);\n\t--color: var(--color-black);\n\tfont-size: 12px;\n\tmin-height: 40px;\n\twidth: 180px;\n}\n\n.mobile {\n\t@include desktop {\n\t\tdisplay: none;\n\t}\n}\n\n.main-desktop {\n\t@include mobile {\n\t\tdisplay: none;\n\t}\n\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\twidth: 100%;\n\theight: 100%;\n\t.left-block,\n\t.right-block {\n\t\twidth: 50%;\n\t}\n\n\t.left-block {\n\t\theight: 100%;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\n\t\t.top {\n\t\t\theight: 55%;\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: column;\n\t\t\tjustify-content: center;\n      align-items: center;\n\t\t\tpadding: 50px;\n\t\t\t.title {\n\t\t\t\tmax-width: 490px;\n\t\t\t\ttext-wrap: balance;\n\t\t\t\tfont-family: AppFontBold;\n\t\t\t\tfont-size: 35px;\n\t\t\t\tline-height: 38px;\n\t\t\t\tletter-spacing: 0em;\n\t\t\t\ttext-align: center;\n\t\t\t\ttext-transform: uppercase;\n\t\t\t\tmargin-bottom: 4.5%;\n\t\t\t}\n\n\t\t\t.main-button {\n\t\t\t\tmin-height: 50px;\n\t\t\t\twidth: 46%;\n\t\t\t\tmax-width: 310px;\n\t\t\t\tmargin: 0 auto 17%;\n\t\t\t\tfont-size: 20px;\n\t\t\t\tline-height: 23.2px;\n\t\t\t\tletter-spacing: 0.02em;\n\t\t\t}\n\n\t\t\t.auth-button {\n\t\t\t\tmin-height: 54px;\n\t\t\t\tmin-width: 218px;\n\t\t\t\tfont-size: 20px;\n\t\t\t\tline-height: 23.2px;\n\t\t\t\tletter-spacing: 0.02em;\n\t\t\t}\n\t\t}\n\n\t\t.full-height {\n\t\t\theight: 100%;\n\t\t}\n\n\t\t.bottom {\n\t\t\theight: 45%;\n\t\t\twidth: 100%;\n\t\t\toverflow: auto;\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: column;\n\t\t\th4 {\n\t\t\t\ttext-transform: uppercase;\n\t\t\t\tpadding-left: 20px;\n\t\t\t}\n\t\t\tswiper-container {\n\t\t\t\twidth: calc(100%);\n\t\t\t\theight: calc(100% - 24px);\n\t\t\t\tpadding-block: 12px;\n\n\t\t\t\t::ng-deep swiper-slide {\n\t\t\t\t\t// div {\n\t\t\t\t\t// \twidth: 100%;\n\t\t\t\t\t// \theight: 100%;\n\t\t\t\t\t// }\n\t\t\t\t\t// .item-container {\n\t\t\t\t\t// \toverflow: auto;\n\t\t\t\t\t// }\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t.right-block {\n\t\theight: 100%;\n\t\tbackground: url('../../../assets/kaisin/background_home_desktop.png') no-repeat center / 100% 100%;\n\t}\n}\n\n.auth-info {\n\tfont-family: AppFontMedium;\n\tfont-size: 18px;\n\tline-height: 21.6px;\n\tletter-spacing: 0.08em;\n\ttext-align: center;\n\ttext-transform: uppercase;\n\tmargin-bottom: 4.1%;\n\n\t@include mobile {\n\t\tcolor: #fff;\n\t}\n\n\t@include desktop {\n\t\tpadding: 0 160px;\n\n\t}\n}\n\nion-footer {\n\t@include desktop {\n\t\tdisplay: none;\n\t}\n}\n\n.footer-wrapper {\n\theight: 72px;\n\tpadding: 20px;\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\n\tborder-top: 1px solid #272727;\n\tbackground: #ebdfda;\n\n\t.auth-info {\n\t\tfont-family: AppFontMedium;\n\t\tfont-size: 10px;\n\t\tline-height: 12px;\n\t\tletter-spacing: 8%;\n\t}\n\n\tion-button {\n\t\tmin-height: 40px;\n\t\tfont-size: 12px;\n\t}\n}\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
